import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  index(activityId, currentPage, perPage) {
    return httpAdminClient.get(`admin/train/activities/${activityId}/schedules`, {
      params: {
        page: currentPage,
        per_page: perPage,
      },
    });
  },
  create(activityId, data) {
    return httpAdminClient.post(`admin/train/activities/${activityId}/schedules`, {
      train_schedule: {
        ...data,
      },
    });
  },
  patch(id, data) {
    return httpAdminClient.patch(`admin/train/schedules/${id}`, {
      train_schedule: {
        ...data,
      },
    });
  },
  delete(id) {
    return httpAdminClient.delete(`admin/train/schedules/${id}`);
  },
  show(id) {
    return httpAdminClient.get(`admin/train/schedules/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/api-course.js